const initMobileNavigation = () => {
    const menuBtn = document.getElementById("menuBtn") as HTMLButtonElement;
    const closeBtn = document.getElementById("close-btn") as HTMLButtonElement;
    const sidebar = document.getElementById("sidebar") as HTMLElement;
    const overlay = document.getElementById("overlay") as HTMLElement;

    const lockScroll = () => {
        const scrollbarWidth =
            window.innerWidth - document.documentElement.clientWidth;
        document.body.style.paddingRight = `${scrollbarWidth}px`;
        document.body.classList.add("lock-scroll");
    };

    const unlockScroll = () => {
        document.body.classList.remove("lock-scroll");
        document.body.style.paddingRight = "";
    };

    const openSidebar = () => {
        sidebar.classList.add("is-active");
        overlay.classList.add("is-active");
        lockScroll();
    };

    const closeSidebar = () => {
        sidebar.classList.remove("is-active");
        overlay.classList.remove("is-active");
        unlockScroll();
    };

    menuBtn.addEventListener("click", openSidebar);
    closeBtn.addEventListener("click", closeSidebar);
    overlay.addEventListener("click", closeSidebar);

    return {
        openSidebar,
        closeSidebar,
    };
};

const initTopBar = () => {
    const topbar = document.querySelector<HTMLElement>(".top-bar");

    function onScroll(): void {
        if (!topbar) {
            throw new Error('Element with class ".top-bar" not found.');
        }
        if (window.scrollY > 0) {
            topbar.classList.add(
                "bg-white/80",
                "backdrop-blur-md",
                "shadow-md"
            );
            topbar.classList.remove("bg-white");
        } else {
            topbar.classList.remove(
                "bg-white/80",
                "backdrop-blur-md",
                "shadow-md"
            );
            topbar.classList.add("bg-white");
        }
    }

    window.addEventListener("scroll", onScroll);
};

const initScrollToTopButton = () => {
    const scrollBtn = document.getElementById("scrollToTop");

    if (scrollBtn) {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 350) {
                scrollBtn.classList.add("opacity-100");
                scrollBtn.classList.remove("opacity-0");
            } else {
                scrollBtn.classList.add("opacity-0");
                scrollBtn.classList.remove("opacity-100");
            }
        });

        scrollBtn.addEventListener("click", () => {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        });
    }
};

const sidebarAPI = initMobileNavigation();
initScrollToTopButton();
initTopBar();
